export default [
  {
    path: '/dashboard/analytics',
    name: 'dashboard-analytics',
    component: () => import('@/views/theme/dashboard/analytics/Analytics.vue'),
    meta: {
      resource: 'home',
      action: 'read',
    },
  },
  {
    path: '/dashboard/ecommerce',
    name: 'dashboard-ecommerce',
    component: () => import('@/views/dashboard/OrganizationDashboard.vue'),
    meta: {
      resource: 'home',
      action: 'read',
    },
  },
]
